export default {
  SET_TOKEN(state, accessToken) {
    state.accessToken = accessToken
  },
  SET_ADMIN_INFO(state, adminInfo) {
    state.adminInfo = adminInfo
  },
  SET_ACTIVE_CHARITY_ID(state, charityId) {
    state.activeCharityId = charityId
  },
}
